import axios from 'axios';

export default {
  selectors: (params = {}, config = {}) => axios.get('taxes/selectors', { params, ...config }),
  groupSelectors: (params = {}, config = {}) => axios.get('taxes/groups/selectors', { params, ...config }),
  preview: (payload = {}, config = {}) => axios.post('taxes/preview', payload, config),
};
